import { FilterField } from "@mm-products/java-multima-framework";
import { listAccountants } from "../../../backend/taxguru/client/taxAccountantClient";
import { store } from "../../../redux/general/reduxStore";
import { resetUserSlice, setCredit, setUserAccountant, setUserClient, setUserInfo } from "../../../redux/userSlice";
import { getCurrentUserSimpleInfo } from "../../../backend/taxguru/client/jmf/coreAccountClient";
import { listClients } from "../../../backend/taxguru/client/taxClientClient";
import operator = FilterField.operator;

export const initializeUserInfo = () =>
    getCurrentUserSimpleInfo()
        .then(({ data }) => {
            store.dispatch(setUserInfo(data));
            return data;
        })
        .catch((err) => {
            console.error(err);
            store.dispatch(resetUserSlice());
            return undefined;
        });
export const initialiseIfAccountant = (userId: string) =>
    listAccountants(
        {
            filters: [{ field: "user.id", value: userId, operator: operator.EQ }],
        },
        undefined,
        undefined,
        true
    )
        .then(({ data }) => data.data && data.data[0])
        .then((data) => {
            if (data) {
                store.dispatch(setUserAccountant(data));
            }
            store.dispatch(setCredit(data?.licence?.credit ?? 0));
        });

export const initialiseIfClient = (userId: string) => {
    return listClients(
        {
            filters: [{ field: "user.id", operator: operator.EQ, value: userId }],
        },
        undefined,
        undefined,
        true
    )
        .then(({ data }) => data.data?.[0])
        .then((data) => {
            if (data) {
                store.dispatch(setUserClient(data));
            }
        });
};
